import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import * as _ from 'lodash';
import { PublicPartnerApiService } from './publicpartnerapi.service';
import { Store } from '@ngrx/store';
import { environment } from './../../../environments/environment';
import { ConfigService } from '@gridscale/ingrid/helper/services/config.service';
import { filter } from 'rxjs';

export interface PublicApiErrorResponse extends HttpErrorResponse {
  method: string;
}


@Injectable({
  providedIn: 'root'
})
export class LegacyPartnerApiService extends PublicPartnerApiService {
  readonly #configService = inject(ConfigService);

  constructor(http: HttpClient, store: Store, publicApi: PublicPartnerApiService) {
    super(http, store);

    this.#configService.ready$.pipe(
      filter(ready => !!ready),
    ).subscribe(() => {
      this.current_endpoint = this.#configService.partnerLegacyApi;
    })


    if (environment.corsProxyUrl && environment.useCorsProxy && !(window as unknown as any).Cypress) {
      this.current_endpoint = environment.corsProxyUrl + this.current_endpoint;
    }

    this.logger = publicApi.logger;
  }
}
